module.exports = __webpack_public_path__ + "img/music_off.5312db64.png";